import {PasswordMeter} from 'password-meter';
import {PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH} from '#api/services/user/userConsts';

const scoreRange = {
	'70' : 'tooWeak',
	'110': 'weak',
	'250': 'medium',
	'_'  : 'strong'
};

class PasswordStrengthMeter {
	constructor(params) {
		this.params = params;
		this.passwordMeter = new PasswordMeter(
			{
				'minLength'                : PASSWORD_MIN_LENGTH,
				'maxLength'                : PASSWORD_MAX_LENGTH,
				'uppercaseLettersMinLength': 1,
				'lowercaseLettersMinLength': 1,
				'numbersMinLength'         : 1
			},
			scoreRange
		);
		
		if (this.params.passwordProgressElement) {
			this._initPasswordProgress();
		}
	}
	
	_initPasswordProgress() {
		this.params.passwordInput.addEventListener(
			'input',
			(ev) => {
				this._updatePasswordProgressClassList(ev.target.value);
			}
		);
		
		requestAnimationFrame(() => {
			this._updatePasswordProgressClassList(this.params.passwordInput.value);
		});
	}
	
	isValidPassword(password) {
		return this.passwordMeter.getResult(password)
					.score > 0;
	}
	
	_updatePasswordProgressClassList(password) {
		const result = this.passwordMeter.getResult(password);
		
		let classBasedOnStrength = 'tooWeak';
		
		if (result.score > 0) {
			classBasedOnStrength = result.status;
		}
		
		const classesBasedOnStrength    = Object.values(scoreRange),
		      passwordProgressClassList = this.params.passwordProgressElement.classList;
		
		let oldClassBasedOnStrength;
		
		for (const currentClass of classesBasedOnStrength) {
			if (passwordProgressClassList.contains(currentClass)) {
				oldClassBasedOnStrength = currentClass;
			}
		}
		
		if (oldClassBasedOnStrength !== classBasedOnStrength) {
			passwordProgressClassList.remove(oldClassBasedOnStrength);
			passwordProgressClassList.add(classBasedOnStrength);
		}
	}
}

export default PasswordStrengthMeter;